var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import Immutable from 'immutable';
import React, { Component } from 'react';
import { Icon } from "../../UI";
import { connect } from 'react-redux';
import { t } from "../../I18N";
import ConnectionsGroup from "./ConnectionsGroup";
import { LibraryViewRelationships } from "./LibraryViewRelationships";

class ConnectionsGroupsComponent extends Component {
  render() {
    const { connectionsGroups, expanded } = this.props;

    let Results = /*#__PURE__*/
    _jsx("div", { className: "blank-state" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "exchange-alt" }), /*#__PURE__*/
    _jsx("h4", {}, void 0, t('System', 'No Relationships')), /*#__PURE__*/
    _jsx("p", {}, void 0, t('System', 'No Relationships description'))
    );


    if (connectionsGroups.size) {
      if (this.props.sidePanelTrigger === 'library') {
        Results = /*#__PURE__*/_jsx(LibraryViewRelationships, { expanded: expanded });
      } else {
        Results = /*#__PURE__*/
        _jsx("div", {}, void 0, /*#__PURE__*/
        _jsx("div", { className: "nested-selector" }, void 0, /*#__PURE__*/
        _jsx("ul", { className: "multiselect is-active" }, void 0,
        connectionsGroups.map((group) => /*#__PURE__*/
        _jsx(ConnectionsGroup, { group: group }, group.get('key'))
        )
        )
        )
        );

      }
    }

    return Results;
  }
}

ConnectionsGroupsComponent.defaultProps = {
  expanded: false
};







function mapStateToProps({ relationships, library }) {
  return {
    connectionsGroups: relationships.list.connectionsGroups,
    sidePanelTrigger: library.sidepanel.view
  };
}

export const ConnectionsGroups = connect(mapStateToProps)(ConnectionsGroupsComponent);